export default {"src":"/_next/static/media/editFile.bad2328f.svg","height":24,"width":24};